import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import cn from 'classnames';
import * as React from 'react';

import { ReactComponent as MultipleOptionsIcon } from '../../assets/images/icon-msku.svg';
import { IResultPriceWithCurrency } from '../../types/shell';
import { Price } from '../index';

import styles from './CampaignViewItem.module.scss';

interface IProps {
  name: string;
  price: IResultPriceWithCurrency;
  hasMsku?: boolean;
  imageUrl?: string;
  className?: string;
  iconClassName?: string;
  additionalInfo?: React.ReactNode;
  details?: React.ReactNode;
  badge?: React.ReactNode;
  hint?: React.ReactNode;
  placeholderIcon?: React.ReactNode;
  defaultView?: boolean;
}
const CampaignViewItem = ({
  name,
  price,
  hasMsku,
  imageUrl,
  className,
  iconClassName,
  additionalInfo,
  details,
  badge,
  hint,
  placeholderIcon = <Inventory2Outlined />,
  defaultView,
}: IProps) => {
  return (
    <div className={cn(styles.inventoryItem, className, { [styles.defaultView]: defaultView })}>
      <div className={cn(styles.iconInner, iconClassName)}>
        {imageUrl ? (
          <div className={styles.icon} style={{ backgroundImage: `url(${imageUrl})` }} />
        ) : (
          <div className={styles.placeholder} data-testid="campaign-view-item-placeholder">
            {placeholderIcon}
          </div>
        )}
        {badge}
        {hint}
      </div>
      <div className={styles.inventoryInfo}>
        <div className={styles.header}>
          <Price value={price} className={styles.price} />
          {details}
        </div>
        <div className={cn(styles.inventoryName)} title={name}>
          {name}
        </div>
        {additionalInfo}
      </div>
      {hasMsku && <MultipleOptionsIcon className={styles.mskuIcon} />}
    </div>
  );
};

export default CampaignViewItem;
